/**
 * Hides the price (.snize-price) and the bottom button row
 * (.snize-buttons-bottom) on Snize search/collection result cards whose
 * title (.snize-title) exactly matches one of the products listed below.
 * Everything else on the card (title, image, etc.) is left untouched —
 * only those two elements are hidden.
 *
 * Snize renders/re-renders its results asynchronously (as you type in
 * search, filter, or paginate), so a single one-time DOM scan on page
 * load isn't enough — newly injected cards would show their price again.
 * A MutationObserver watches the page continuously and re-applies the
 * hide rule to any new .snize-title elements Snize adds.
 */
(function () {
  var HIDDEN_TITLES = [
    'Val 6 Daystar Infrared Heater',
    'Val 6 EPX Heater',
    'Val 6 KBE5L Portable Heater',
    'Val 6 MPX'
  ];

  // Case/whitespace-insensitive matching so small markup differences
  // (extra spaces, stray line breaks) don't cause a silent miss.
  var normalized = HIDDEN_TITLES.map(function (title) {
    return title.trim().toLowerCase();
  });

  var HIDDEN_SELECTORS = ['.snize-price', '.snize-buttons-bottom'];

  function hideElementsForTitle(titleEl) {
    var titleText = (titleEl.textContent || '').trim().toLowerCase();
    if (normalized.indexOf(titleText) === -1) return;

    // The price and button-row elements are usually siblings within the
    // same product card, not direct siblings of the title itself, so
    // walk up to the nearest reasonable card wrapper and hide them
    // within it.
    var card =
      titleEl.closest('.snize-product') ||
      titleEl.closest('.snize-product-info') ||
      titleEl.closest('[class*="snize-product"]') ||
      titleEl.parentElement;

    if (!card) return;

    HIDDEN_SELECTORS.forEach(function (selector) {
      card.querySelectorAll(selector).forEach(function (el) {
        el.style.display = 'none';
        el.setAttribute('data-hidden-by-title-match', 'true');
      });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.snize-title').forEach(hideElementsForTitle);
  }

  // Initial pass in case results are already on the page.
  scan();

  // Watch for Snize injecting/re-rendering result cards and re-apply.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return; // only element nodes

        if (node.matches && node.matches('.snize-title')) {
          hideElementsForTitle(node);
        }

        if (node.querySelectorAll) {
          scan(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();